import "core-js/modules/es.array.join.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get, post } from '@api/request';
import { mtrlAPI } from '@api/modules/mtrl';
import { optnAPI } from '@api/modules/optn';
import pubPagination from '@/components/common/pubPagination';
import publicTips from '@/views/component/publicTips';
import helper from '@assets/js/helper.js';
export default {
  name: 'SmplEditBom',
  components: {
    pubPagination: pubPagination,
    publicTips: publicTips
  },
  props: {
    smplForm: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      tableData: [],
      searchForm: {
        mtrl_no: null,
        mtrl_name: null,
        dept_id: null,
        mtrl_type: 1,
        mtrl_color: null,
        colr_class: []
      },
      totalPage: 0,
      btn: {},
      loading: true,
      multiSelection: [],
      currentPage: 1,
      mtrlType: [{
        id: 0,
        label: '原面料'
      }, {
        id: 1,
        label: '辅料'
      }, {
        id: 2,
        label: '包材'
      }],
      title: '提示：相同数据仅限导入一条',
      optnColorList: [],
      deptType: []
    };
  },
  created: function created() {
    this.initData();
  },
  filters: {
    formaUnitM: function formaUnitM(row) {
      return helper.haveFour(row) + '米';
    },
    formaUnitH: function formaUnitH(row) {
      return helper.reservedDigits(row) + '毫米';
    }
  },
  methods: {
    initData: function initData() {
      this.loading = true;
      this.getMtrlsList();
      this.getOptnColor();
      this.getDeptList();
    },
    // 获取物料信息
    getMtrlsList: function getMtrlsList() {
      var _this = this;

      this.searchForm.dept_id = this.$cookies.get('userInfo').dept_id;
      var searchBody = JSON.parse(JSON.stringify(this.searchForm));
      searchBody.page_no = this.currentPage; // 添加单据
      // searchBody.belo_dept_id  = this.smplForm.belo_dept_id
      // searchBody.status=2;

      var colr_class = null;

      if (this.searchForm.colr_class.length > 0) {
        colr_class = this.searchForm.colr_class.join(',');
      }

      searchBody.colr_class = colr_class;
      get(mtrlAPI.getMtrls, searchBody).then(function (res) {
        if (res.data.code === 0) {
          _this.tableData = res.data.data.list;
          _this.totalPage = res.data.data.total;
          _this.btn = res.data.data.btn;
          setTimeout(function () {
            _this.loading = false;
          }, 300);
        } else {
          var mg = res.data.msg;
          var tp = 'error';

          _this.$message({
            message: mg,
            type: tp
          });

          setTimeout(function () {
            _this.loading = false;
          }, 300);
        }
      }).catch(function () {
        setTimeout(function () {
          _this.loading = false;
        }, 300);
      });
    },
    //获取颜色大类option
    getOptnColor: function getOptnColor() {
      var _this2 = this;

      get(optnAPI.getAllContent, {
        perm_id: 10010
      }).then(function (res) {
        if (res.data.code === 0) {
          _this2.optnColorList = res.data.data;
          return;
        }

        _this2.$message.error(res.data.msg);
      }).catch(function (res) {
        _this2.$message.error(res.data.msg);
      });
    },
    //获取部门
    getDeptList: function getDeptList() {
      var _this3 = this;

      get(optnAPI.getOptnByPermId, {
        perm_id: 10009
      }).then(function (res) {
        if (res.data.code === 0) {
          _this3.deptType = res.data.data.form.optn_cntt_list;
          console.log();
          return;
        }

        _this3.$message.error(res.data.msg);
      }).catch(function (res) {
        _this3.$message.error(res.data.msg);
      });
    },
    // 清空
    clear: function clear() {
      this.$refs.multiTable.clearSelection();
    },
    // 查询方法
    getMtrlsNow: function getMtrlsNow() {
      this.$refs.pubPagination.currentPage = 1;
      this.loading = true;
      this.currentPage = 1;
      this.getMtrlsList();
    },
    // 刷新
    getMtrlsNowO: function getMtrlsNowO() {
      this.$refs.pubPagination.currentPage = 1;
      this.loading = true;
      this.currentPage = 1;
      this.searchForm = {
        dept_id: null,
        mtrl_no: null,
        mtrl_name: null,
        mtrl_type: 1,
        mtrl_color: null,
        colr_class: []
      }, this.getMtrlsList();
    },
    // 转换合同状态
    getStatusName: function getStatusName(status) {
      if (status === 1) {
        return {
          name: '库存充足',
          type: 'success'
        };
      } else if (status === 0) {
        return {
          name: '库存不足',
          type: 'warning'
        };
      }
    },
    // 指定一个key标识这一行的数据
    getRowKey: function getRowKey(row) {
      return row.mtrl_id;
    },
    // 多选
    handleSelectionChange: function handleSelectionChange(val) {
      this.multiSelection = [];
      this.multiSelection = val;
    },
    // 分页查询
    changePageSearch: function changePageSearch(val) {
      this.currentPage = val;
      this.getMtrlsList();
    },
    // 物料类型
    formatLeavType: function formatLeavType(row) {
      if (row.mtrl_type === 0) {
        return '原面料';
      } else if (row.mtrl_type === 1) {
        return '辅料';
      } else if (row.mtrl_type === 2) {
        return '包材';
      }
    },
    // 图片类型
    formatPic: function formatPic(scope, type) {
      var updateTime = JSON.parse(JSON.stringify(new Date().getTime()));
      return this.helper.picUrl(scope.row.imge_url, type, updateTime);
    },
    // 时间转换
    formatDate: function formatDate(row) {
      return this.helper.toStringDate(row.create_time);
    },
    // //新增
    goMtrl: function goMtrl() {
      this.$emit('falseBom');
      this.jump("/mtrl_list?perm_id=".concat(this.helper.retPermId('mtrl')));
    },
    // 取消选择
    cancel: function cancel() {
      this.clear();
      this.$emit('bomChildChanelCopy', false);
    },
    // 确认选择
    confirmIn: function confirmIn() {
      if (this.multiSelection.length > 0) {
        this.$emit('childBomCopy', this.multiSelection, 0);
      } else {
        this.$message({
          message: '至少选择一条信息',
          type: 'warning'
        });
      }
    },
    // 选未选中提示
    doDelete: function doDelete() {
      if (this.multiSelection.length === 0) {
        this.$message({
          type: 'warning',
          message: '请至少选择一条数据！'
        });
      } else {
        this.mBox();
      }
    }
  }
};